import * as ActionTypes from '../commonActionTypes'

export const initializeDropDownValues=(payload) =>{
    return {
        type: ActionTypes.INITIALIZE_DROPDOWNS,
        payload:payload
    }
}


export const clearDropdown = () => {
    return {
      type: ActionTypes.CLEAR_DROPDOWN,
    }
  }
